"use strict";
/* eslint-disable guard-for-in */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UEventEmitter = void 0;
/**
 * 事件存取触发器，提供一种 事件交互 的机制
 * 这里可以用 on 去监听一个事件
 * 用emit去触发执行事件
 * 适用于全局性质的事件交互，减少 props 的深度传递
 */
var ioc_1 = require("@baidu/ioc");
var UEventEmitter = /** @class */ (function () {
    function UEventEmitter() {
        this.events = {};
    }
    /**
     * 只执行一次
     * @param eventname
     * @param handler
     */
    UEventEmitter.prototype.once = function (eventname, handler) {
        this.addEvent(eventname, handler, true);
        return this;
    };
    /**
     * 添加监听
     * @param eventname
     * @param handler
     * @param isMultiple 是否多次添加相同name的handler
     */
    UEventEmitter.prototype.on = function (eventname, handler, isMultiple) {
        if (isMultiple === void 0) { isMultiple = true; }
        var event = this.events[eventname];
        if (event && !isMultiple) {
            return this;
        }
        this.addEvent(eventname, handler, false);
        return this;
    };
    UEventEmitter.prototype.addEvent = function (eventname, handler, once) {
        if (once === void 0) { once = false; }
        if (typeof eventname === 'function') {
            // eslint-disable-next-line no-param-reassign
            once = handler;
            // eslint-disable-next-line no-param-reassign
            handler = eventname;
            // eslint-disable-next-line no-param-reassign
            eventname = 'default';
        }
        if (!this.events[eventname]) {
            this.events[eventname] = [];
        }
        this.events[eventname].push({
            handler: handler,
            once: once,
        });
    };
    /**
     * 销毁
     */
    UEventEmitter.prototype.destroy = function () {
        for (var i in this.events) {
            var events = this.events[i];
            events.forEach(function (event) {
                delete event.handler;
                delete event.once;
            });
            delete this.events[i];
        }
    };
    // 删除
    UEventEmitter.prototype.delete = function (eventname) {
        var handler = this.events[eventname];
        if (handler) {
            delete this.events[eventname];
        }
    };
    /**
     * 触发
     * @param eventname
     * @param data
     */
    UEventEmitter.prototype.emit = function (eventname) {
        if (eventname === void 0) { eventname = 'default'; }
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        if (this.events[eventname]) {
            // 存在这个处理
            // eslint-disable-next-line @typescript-eslint/no-for-in-array
            for (var i in this.events[eventname]) {
                var item = this.events[eventname][i];
                item.handler.apply(null, data);
            }
            this.events[eventname] = this.events[eventname].filter(function (item) {
                var isOnce = item.once;
                if (isOnce) {
                    delete item.handler;
                    delete item.once;
                }
                return !isOnce;
            });
        }
        return this;
    };
    UEventEmitter = __decorate([
        (0, ioc_1.Injectable)()
    ], UEventEmitter);
    return UEventEmitter;
}());
exports.UEventEmitter = UEventEmitter;
